import Icons from "components/Icons";
import React from "react";
import { connect } from "react-redux";
import { DateTime } from "luxon";
import strings from "utils/strings";
import "./styles.scss";

import UserPlaceholder from "assets/images/placeholders/user2x.jpg";
import { push } from "connected-react-router";

class SimpleAppointmentCard extends React.Component<any, any> {
	render() {
		const {
			appointment,
			simple = false,
			empty = false,
			onClick,
			language,
			noButton = false,
			isPsychologist,
			noHeader = false,
			homeUser = false,
			dispatch,
			onCardClick
		} = this.props;

		const name = isPsychologist
			? appointment?.user?.name
			: appointment?.psychologist?.externalName || appointment?.psychologist?.name;
		const photo = isPsychologist
			? appointment?.user?.photo || UserPlaceholder
			: appointment?.psychologist?.photo || UserPlaceholder;

		const showButton = DateTime.utc() >= DateTime.fromISO(appointment?.startDate).minus({ minutes: 30 });

		return (
			<div
				className={`SimpleAppointmentCardWrapper${simple ? " --card-simple" : ""}${
					empty || homeUser ? " --card-empty" : ""
				}`}
				onClick={(e: any) => {
					if (typeof onCardClick === "function") {
						e.stopPropagation();
						onCardClick();
					}
				}}
			>
				{!simple && !noHeader && (
					<div className="AppointmentType">
						<p>{empty ? strings.home.psychologicalAppointment : strings.appointments.type}</p>
					</div>
				)}
				<div className="AppointmentDetailsWrapper">
					<div className="AppointmentDetails">
						{!empty && (
							<div
								className={`PsychologistAvatar${isPsychologist ? " --clickable" : ""}`}
								onClick={() => {
									if (isPsychologist) {
										dispatch(push(`/patients/${appointment?.user?._id}`));
									}
								}}
							>
								<img src={photo} alt="psychologist avatar" />
							</div>
						)}
						<div className="PsychologistDetails">
							<p
								onClick={() => {
									if (isPsychologist) {
										dispatch(push(`/patients/${appointment?.user?._id}`));
									}
								}}
								className={isPsychologist ? " --clickable" : ""}
							>
								{name}
							</p>
							{empty ? (
								<div className="CardRow">
									<div className="CardRowIconWrapper --card-empty">
										<Icons.Calendar color={simple ? "blue" : "white"} />
										<p>{strings.home.scheduleVideoAppointment}</p>
									</div>
								</div>
							) : (
								<div className="CardRow">
									<div className="CardRowIconWrapper">
										<Icons.Calendar smaller color={simple ? "blue" : "white"} />
										<p>
											{DateTime.fromISO(appointment?.startDate)
												.setLocale(language)
												.toFormat("dd LLLL yyyy")}
										</p>
									</div>
									<div className="CardRowIconWrapper">
										<Icons.Clock color={simple ? "blue" : "white"} />
										<p>{DateTime.fromISO(appointment?.startDate).toFormat("HH:mm")}H</p>
									</div>
								</div>
							)}
						</div>
					</div>
					{!noButton && !simple && empty && (
						<div className="AppointmentVideoContainer">
							<button
								onClick={() => {
									if (typeof onClick === "function") {
										onClick();
									}
								}}
								className="VideoIconWrapper"
							>
								{<Icons.Arrow />}
							</button>
						</div>
					)}
					{!noButton && !simple && !empty && showButton && (
						<div className="AppointmentVideoContainer">
							<button
								onClick={() => {
									if (typeof onClick === "function") {
										onClick();
									}
								}}
								className="VideoIconWrapper"
							>
								{<Icons.Camera />}
							</button>
						</div>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language
});

export default connect(mapStateToProps)(SimpleAppointmentCard);
